// User preferences, persisted locally. One key, one shape, read-through
// helpers — components must never touch localStorage for prefs directly,
// or the shape drifts per call site.
const KEY = 'wizardly_prefs';

const DEFAULTS = {
  defaultModel: null,        // null = "decide for me" (the product default)
  confirmCost: false,        // ask before each generation with a cost estimate
  fontSize: 'medium',        // small | medium | large
  language: 'en',
  timezone: null,            // null = browser default
  dateFormat: 'DD/MM/YYYY',
  notifications: {
    email: false,
    inApp: true,
    mentions: true,
    generationComplete: true,
  },
};

export function getPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULTS,
      ...parsed,
      notifications: { ...DEFAULTS.notifications, ...(parsed.notifications || {}) },
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setPrefs(next) {
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* storage full/blocked — prefs simply don't persist */ }
  return next;
}

// The base font size is applied at the document root so rem-based Tailwind
// sizing scales the whole app uniformly.
const FONT_PX = { small: '14px', medium: '16px', large: '18px' };
export function applyFontSize(size) {
  try {
    document.documentElement.style.fontSize = FONT_PX[size] || FONT_PX.medium;
  } catch { /* SSR / non-DOM */ }
}
